module.exports = __webpack_public_path__ + "img/20241023_manavisfesta.a61d7aa4.jpg";